import { Button, Modal, Text } from "@alpacahq/ui/old";

interface DisclaimerModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DisclaimerModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: DisclaimerModalProps) => (
  <Modal
    title="Disclaimer"
    isOpen={isOpen}
    onClose={onCancel}
    controls={
      <div className="flex items-center justify-end gap-4">
        <Button variant="v2/stroke" onClick={onCancel} type="button">
          Cancel
        </Button>
        <Button variant="v2/filled" onClick={onConfirm} type="button">
          I acknowledge
        </Button>
      </div>
    }
  >
    <div className="border-t border-t-gray-300 border-b border-b-gray-300">
      <Text className="py-4 text-gray-700 text-sm">
        Unless otherwise indicated in the instruction above, please transfer
        in-kind, all assets into my account with AlpacaSecurities LLC.
        <br />
        <br />I understand that to the extent any assets in my account are not
        readily transferable with or without penalties such assets may not be
        transferred within the timeframes required by applicable regulations.
        <br />
        <br />I understand I will be contracted by the delivering and/or
        receiving firm regarding any assets that are not transferable.
        <br />
        <br />I authorize you to liquidate any non-transferable proprietary
        money market fund assets that are part of my account and transfer the
        resulting credit balance to Alpaca Securities LLC. I authorize the
        transferor to deduct any outstanding fees due you from the credit
        balance in my account. If my account does not contain a credit balance,
        or if the credit balance in the account is insufficient to satisfy any
        outstanding fees due you, I authorize you to liquidate the assets in my
        account to the extent necessary to satisfy that obligation.
        <br />
        <br />I understand that upon receiving a copy of this transfer
        instruction, for a full account transfer, transferor will freeze my
        account and cancel all open orders for my account on your books. I
        affirm that have destroyed or returned to the transferor all
        credit/debit cards and or unused checks issued to me in connection with
        my account.
      </Text>
    </div>
    <Text className="py-4 text-gray-500 text-xs">
      By proceeding to confirm and sign for your Portfolio Transfer, you
      acknowledge that you have carefully read and understood the accompanying
      disclaimer.
    </Text>
  </Modal>
);
